import {
  getColorNumberForUserAvatar,
  getInitials,
  UserEntity
} from "@/domain/user"
import {
  DATE_TIME_SHORT_FORMAT,
  getDateFromSeconds,
  getDateInFormat
} from "@/helpers/date.helpers"

import {
  getInputFilter,
  getMultipleValuesFilter
} from "@/helpers/filters.helper"

import type { FilterUsersResponse, UsersResponse } from "@/api/useUsers.types"
import type { TFunction } from "@/hooks/useTranslation"

export const getUsersData = (response: UsersResponse) => {
  const { data, metadata } = response || {}

  return {
    metadata,
    data: data.map<UserEntity>((user) => {
      return {
        initials: getInitials(user.email),
        key: user.email,
        colorNumber: getColorNumberForUserAvatar(user.email),
        ...user,
        lastLogin:
          user.lastLogin === undefined
            ? ""
            : getDateInFormat(
                getDateFromSeconds(user.lastLogin),
                DATE_TIME_SHORT_FORMAT
              )
      }
    })
  }
}

export const getFiltersKeys = () => [
  "name",
  "jobDescription",
  "role",
  "status",
  "scope"
]

export const getFiltersUsersSelector = (
  response: FilterUsersResponse,
  t: TFunction
) => {
  const { data, ...restResponse } = response || {}
  const getOptions = (data: string[], key: string) =>
    (data || []).map((value) => ({
      label: t(`${key}.${value}`),
      value
    }))

  const role = getMultipleValuesFilter("role", t, {
    options: getOptions(data?.role, "settings.users.roles")
  })

  const status = getMultipleValuesFilter("status", t, {
    options: getOptions(data?.status, "settings.users")
  })

  const scope = getMultipleValuesFilter("scope", t, {
    options: (data?.scope || []).map(({ id, name }) => ({
      label: name,
      value: id
    }))
  })

  const filters = getFiltersKeys().map((key) => {
    if (key === "role") return role
    if (key === "status") return status
    if (key === "scope") return scope

    return getInputFilter(key, t)
  })

  return {
    data: { role, status, scope, all: filters },
    ...restResponse
  }
}
